export const projects = [
  {
    title: "Scythe Robotics Mobile App",
    subtitle: "Fleet Management Application",
    description:
      "Led the development of a comprehensive fleet management mobile application for Scythe Robotics' autonomous commercial mowers. The app provides real-time monitoring, control, and management capabilities for landscape contractors.",
    disclaimer:
      "All information presented here is publicly available through app stores and official channels.",
    technologies: [
      { name: "React Native", url: "https://reactnative.dev" },
      { name: "TypeScript", url: "https://www.typescriptlang.org" },
      { name: "Node.js", url: "https://nodejs.org" },
      { name: "GraphQL", url: "https://graphql.org" },
      { name: "AWS", url: "https://aws.amazon.com" },
      { name: "Google Maps API", url: "https://developers.google.com/maps" },
    ],
    appStoreUrl: "https://apps.apple.com/us/app/scythe-robotics/id1671836132",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.scytherobotics.takeout",
    featured: true,
    screenshots: {
      iphone: [
        {
          src: "/images/portfolio/scythe/iphone/home.png",
          alt: "iPhone - Home screen showing mower fleet overview",
        },
        {
          src: "/images/portfolio/scythe/iphone/map.png",
          alt: "iPhone - Interactive map with real-time mower locations",
        },
        {
          src: "/images/portfolio/scythe/iphone/mower-details.png",
          alt: "iPhone - Detailed mower status and controls",
        },
        {
          src: "/images/portfolio/scythe/iphone/zones.png",
          alt: "iPhone - Zone management and geofencing",
        },
        {
          src: "/images/portfolio/scythe/iphone/schedule.png",
          alt: "iPhone - Mowing schedule and automation settings",
        },
        {
          src: "/images/portfolio/scythe/iphone/analytics.png",
          alt: "iPhone - Performance analytics and reporting",
        },
      ],
      ipad: [
        {
          src: "/images/portfolio/scythe/ipad/home.png",
          alt: "iPad - Home screen with expanded mower fleet view",
        },
        {
          src: "/images/portfolio/scythe/ipad/map.png",
          alt: "iPad - Full-screen map with mower locations",
        },
        {
          src: "/images/portfolio/scythe/ipad/mower-details.png",
          alt: "iPad - Detailed mower controls and status",
        },
        {
          src: "/images/portfolio/scythe/ipad/zones.png",
          alt: "iPad - Advanced zone management interface",
        },
        {
          src: "/images/portfolio/scythe/ipad/schedule.png",
          alt: "iPad - Comprehensive scheduling dashboard",
        },
        {
          src: "/images/portfolio/scythe/ipad/analytics.png",
          alt: "iPad - Detailed performance metrics and analytics",
        },
      ],
    },
  },
  {
    title: "Master's Thesis Research",
    subtitle: "Learning Software Development: When Do Students Need Help?",
    location: "Penn State University",
    description:
      "An investigation into the critical moments when students seek assistance while learning software development. Through surveys and interviews with college-level students, this research analyzes the factors influencing resource consultation, effectiveness of EdPsych learning methods, and the role of peer collaboration in the software development learning process.",
    technologies: [
      { name: "Software Development Education" },
      { name: "Debugging Strategies" },
      { name: "Educational Psychology" },
      { name: "Survey Design" },
      { name: "Interview Techniques" },
      { name: "Data Analysis" },
    ],
    demoUrl: "https://etda.libraries.psu.edu/catalog/16471bxe5056",
    pdfUrl:
      "/fileFolder/thesis/EppingerBenjamin_Thesis_LearningSoftwareDevelopment.pdf",
    demoLabel: "Penn State ETDA",
    isPdf: true,
    presentations: [
      {
        title: "Defense Presentation",
        url: "/fileFolder/thesis/EppingerBenjamin_ThesisDefense.pptx",
      },
    ],
  },
  {
    title: "Machine Learning Research Projects",
    subtitle: "IST 597 - ProjectFi & Content Moderation",
    location: "Penn State University",
    description:
      "A collection of machine learning research projects, including ProjectFi and content moderation systems.",
    technologies: [
      { name: "Machine Learning" },
      { name: "AI" },
      { name: "Data Analysis" },
      { name: "Python" },
    ],
    presentations: [
      {
        title: "ProjectFi Proposal",
        url: "https://bentheitguy.me/fileFolder/Eppinger597ProposalPresentation.pptx",
      },
      {
        title: "ProjectFi Final",
        url: "https://bentheitguy.me/fileFolder/Eppinger597ProjectPresentation.pptx",
      },
      {
        title: "Content Moderation",
        url: "https://bentheitguy.me/fileFolder/Module11PPT.pptx",
      },
    ],
  },
  {
    title: "Academic Research & Projects",
    subtitle: "IST 505 & IST 525",
    location: "Penn State University",
    description:
      "Various academic research projects and presentations in Information Sciences and Technology.",
    technologies: [
      { name: "Research Methods" },
      { name: "Data Analysis" },
      { name: "Technical Writing" },
    ],
    presentations: [
      {
        title: "IST 505 Project Proposal",
        url: "https://bentheitguy.me/fileFolder/IST505-ProposalPresentation.pptx",
      },
      {
        title: "IST 525 Project Poster",
        url: "https://bentheitguy.me/fileFolder/525Poster.pptx",
      },
    ],
  },
  {
    title: "CareBnB",
    subtitle: "IST 413 - Healthcare Accommodation Platform",
    location: "Penn State University",
    description:
      "A high-fidelity prototype for a healthcare accommodation booking platform, designed to help patients find lodging near medical facilities.",
    technologies: [
      { name: "Adobe XD", url: "https://www.adobe.com/products/xd.html" },
      { name: "UI/UX Design" },
      { name: "Prototyping" },
      { name: "User Research" },
    ],
    demoUrl:
      "https://bentheitguy.me/fileFolder/CareBnB_StoryBoard_All_Streamlined_FontRoboto.xd",
  },
  {
    title: "Portfolio Website",
    subtitle: "Personal Portfolio",
    description:
      "A modern, responsive portfolio website built with React and Tailwind CSS.",
    technologies: [
      { name: "React", url: "https://reactjs.org" },
      { name: "Tailwind CSS", url: "https://tailwindcss.com" },
      { name: "Framer Motion", url: "https://www.framer.com/motion" },
      { name: "GitHub Pages", url: "https://pages.github.com" },
      { name: "GitHub Actions", url: "https://github.com/features/actions" },
    ],
    githubUrl: "https://github.com/bxe5056/bxe5056.github.io",
  },
];
